<template>
	<div id="pay">
    <!-- <van-submit-bar
      :price="3050"
      button-text="提交订单"
      @submit="onSubmit"
    /> -->
    <van-button plain type="primary" @click="doPay">支付</van-button>
	</div>
</template>
<script>  
  import { Button,SubmitBar } from 'vant';
	export default {
    components: {
      [Button.name]: Button,
		  [SubmitBar.name]: SubmitBar,
		},
		data() {
			return {

			}
		},
		mounted() {
		},
		methods: {
      doPay(){
        this.$router.push({ name: 'PayFail',	query: {	}});
       // this.$router.push({ name: 'PaySuccess',	query: {	}});
        return;
        //调用支付接口
        let _this = this;
				let url = Global.env + Global.apiCore.homePage;
				return new Promise((resolve, reject) => {
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
               WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId":json.appId,     //公众号名称，由商户传入
                    "timeStamp": json.timeStamp,         //时间戳，自1970年以来的秒数
                    "nonceStr":json.nonceStr, //随机串
                    "package":json.packAge,
                    "signType":"MD5",         //微信签名方式：
                    "paySign":json.paySign //微信签名
                },
                function(res){
                  alert('支付成功')
                   // window.location.href = "/userBaseInfo/indexPage";
                }
              );
							return resolve()
						} else {
							return reject(response.resultDesc);
						}
					}).catch(error => {
            alert('支付失败')
						return reject(error);
					})
        })
        return;
        $.ajax({
            url: "/wechat/toPayPage?openid=" + openid + "&buyType=" + buyType,
            type: "get",
            dataType: "json",
            success: function (json) {
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                        "appId":json.appId,     //公众号名称，由商户传入
                        "timeStamp": json.timeStamp,         //时间戳，自1970年以来的秒数
                        "nonceStr":json.nonceStr, //随机串
                        "package":json.packAge,
                        "signType":"MD5",         //微信签名方式：
                        "paySign":json.paySign //微信签名
                    },
                    function(res){
                        window.location.href = "/userBaseInfo/indexPage";
                    }
                );
            },
            error: function (e) {
                status = "on";
                alert("获取支付信息失败");
            }
        });
      }
		}
	}
</script>
<style lang="scss" scope>
	
</style>
